<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">{{ title }}</h4>
            <div class="row mb-2 ">
              <div class="col-sm-8">
              </div>
              <div class="col-sm-4">
                <div class="float-sm-end d-flex">
                  <div class="text-sm-right me-2">
                    <button type="button" class="btn  btn-primary btn-rounded mb-2 mr-2" @click="showFilters()">
                      <i class="mdi mdi-filter mr-1"></i> Filtros
                    </button>
                  </div>
                  <div class="text-sm-right">
                    <button type="button" class="btn  btn-success btn-rounded mb-2 mr-2" @click="exportResultQuiz()">
                      <i class="mdi mdi-file-export-outline mr-1"></i> Exportar Dados
                    </button>
                  </div>
                </div>
              </div>
              <!-- end col-->
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead>
                  <tr>
                    <th width="25%">Nome</th>
                    <th>E-mail</th>
                    <th width="25%">Sala</th>
                    <th width="10%">Respondidas</th>
                    <th width="10%">Acertos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in results" :key="list.id">
                    <td>{{ list.name }}</td>
                    <td>{{ list.email }}</td>
                    <td>{{ list.room_name }}</td>
                    <td>{{ list.total_answered }}</td>
                    <td>{{ list.total_correct }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-filter ref="modalFilter" @quizFiltered="getReport"></modal-filter>
  </div>
</template>
<script>
// Import component
import appConfig from '@/app.config'
import serviceReport from '../services'
import modalFilter from '@/components/modals/filters/QuizFilter'

export default {
  components: {
    modalFilter
  },
  name: 'report-quiz',
  page: {
    title: 'Relatório de Quiz',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      params: {},
      totalRows: 1,
      rows: 0,
      currentPage: 1,
      results: [],
      perPage: 20,
      title: 'Relatório de Quiz'
    }
  },
  mounted () {
    let loeader = this.$loading.show()
    serviceReport.listResultQuiz({ limit: this.perPage }).then((res) => {
      this.results = res.data
      this.rows = res.total
      this.currentPage = res.current_page
      loeader.hide()
    }).catch(error => {
      console.log(error)
      loeader.hide()
    })
    this.totalRows = this.rows
  },
  created () {},
  computed: {
  },
  methods: {
    showFilters () {
      this.$refs.modalFilter.open()
    },
    exportResultQuiz () {
      let loeader = this.$loading.show()
      serviceReport.exportResultQuiz(this.params).then((res) => {
        this.download(res)
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    getReport (filter) {
      let loeader = this.$loading.show()
      let params = {
        quiz_id: filter.quiz_id || null,
        room_id: filter.room_id || null,
        limit: this.perPage,
        page: this.currentPage
      }
      this.params = params
      serviceReport.listResultQuiz(params).then((res) => {
        this.results = res.data
        if (res.data.length > 0) {
          this.rows = res.total
          this.currentPage = res.current_page
        }
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    updateList () {
      this.getReport(this.params)
    }
  },
  watch: {
    currentPage () { this.updateList() },
    total () { this.updateList() },
    dataPerPage () { this.updateList() }
  }
}
</script>
<style scoped>
.link { cursor: pointer; }
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { min-height: 300px;}
.float-sm-end { float: right }
</style>
